var map = {
	"./64_hat.mp3": "b6ca",
	"./65_T-shirt.mp3": "4899",
	"./66_dress.mp3": "8fdb",
	"./67_jumper.mp3": "c164",
	"./68_jacket.mp3": "f11f",
	"./69_shoes.mp3": "cfaa",
	"./70_jeans.mp3": "ffa3",
	"./M_Brilliant.mp3": "badd",
	"./M_Excellent.mp3": "49ee",
	"./M_Fantastic.mp3": "571c",
	"./M_Great.mp3": "492e",
	"./M_Perfect.mp3": "8d42",
	"./M_Think again.mp3": "e700",
	"./M_Try again.mp3": "232f",
	"./M_Very good.mp3": "bdbe",
	"./M_Well done.mp3": "6f9c",
	"./M_Work harder.mp3": "8723",
	"./click.mp3": "f4a3",
	"./false.mp3": "e607",
	"./true.mp3": "348d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "401c";